<template>
	<table class="table table-striped- table-bordered table-hover table-checkable" :id="this.tableId">
		<thead>
			<tr id="theader" />
			<tr v-if="this.columnSearch && this.columnSearch.length > 0" id="theaderSearch" />
		</thead>
		<tfoot>
			<tr id="tfooter" />
		</tfoot>
	</table>
</template>

<script>
	export default {
		props: ['tableId', 'header', 'columns', 'columnDefs', 'data', 'onEditRow', 'onDeleteRow', 'columnSearch', 'drawCallback'],

		data(){
			return {
				tableHeader: this.header
			};
		},

    	watch: {
    		data: function(d){
    			this.initTable(d);
    		},
    		header: function(h){
    			this.tableHeader = h;
    			this.initTable();
    		}
    	},

	    methods: {
	        initTable: function(data = null){
	        	data = data ? data : this.data;
	        	if(this.tableHeader.length != this.columns.length) return;

	        	if( $.fn.dataTable.isDataTable("#" + this.tableId) ){
	        		$("#" + this.tableId).DataTable().destroy();
	        		$("#" + this.tableId + " tbody").remove();
	        	}

	        	let vm = this;

        		let opt = {
					responsive: false,
					dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
					iDisplayLength: 25,
	                bSort: false,

					data: data,

					columns: [...this.columns],

					drawCallback: function( settings ) {
						if(vm.drawCallback){
							vm.drawCallback();
						}

						if(vm.onEditRow){
							$(".actionLinks .edit").unbind("click").bind("click", function(e){
		                		let code = $(this).attr("code");
			                	vm.onEditRow(code, e);
			                });
						}
						
						if(vm.onDeleteRow){
							$(".actionLinks .delete").unbind("click").bind("click", function(e){
		                		let code = $(this).attr("code");
			                	vm.onDeleteRow(code, e);
			                });
						}
				    }
				};

				if(this.columnDefs) opt.columnDefs = [...this.columnDefs];
				let headers = [...this.tableHeader];

				if(vm.onEditRow || vm.onDeleteRow){
					if(headers[headers.length - 1] != "Actions"){
						headers.push("Actions");
						opt.columns.push({data: 'id'});
						opt.columnDefs.push({
							targets: opt.columns.length - 1,
							render: function(data, type, full, meta) {
								return '<div class="actionLinks">' +
					                     (vm.onEditRow ? '<a class="edit" rid="'+full.id+'" code="'+full.code+'" href="javascript:;">Sửa</a> ' : '') +
					                     (vm.onDeleteRow ? '<a class="delete" rid="'+full.id+'" code="'+full.code+'" href="javascript:;">Xóa</a> ' : '') +
					                     '</div>';
							}
						});
					}
				}

				$("#theader").html(headers.map((e) => {
					return "<th>"+e+"</th>";
				}).join());
				$("#theaderSearch").html(headers.map((e,i) => {
					let search = vm.columnSearch.filter(x => x.pos == i);
					if(search.length <= 0) return "<th />";

					search = search[0];
					return "<th>" + 
								"<input type='text' class='search_form form-control "+((search.type && search.type == "date")?"bydatepicker":"")+"' style='width:95%;' placeholder='Lọc " + e.toLowerCase() +"' />" +
							"</th>";
				}).join());
				$("#tfooter").html(headers.map((e) => {
					return "<th>"+e+"</th>";
				}).join());

				var table = $("#" + this.tableId).DataTable(opt);

				$('.bydatepicker').daterangepicker({
					singleDatePicker: true,
					showDropdowns: true,
					minYear: 2019,
					autoUpdateInput: false,
					locale: {
				    	format: 'YYYY-MM-DD'
				    },
					maxYear: parseInt(moment().format('YYYY'),2)
				}, function(start, end, label) {
					$('.bydatepicker').val(start.format("YYYY-MM-DD")).trigger("change");
				});

				table.columns().every( function () {
                    let _self = this;

                    $( 'input', this.header() ).on( 'keyup change', function () {
                        if ( _self.search() !== this.value ) {
                            _self.search( this.value ).draw();
                        }
                    });
                });
	        }
	    }
	}

</script>

<style>
	table{
		text-align: center;
	}
	table tbody .sms,
	table tbody .code{
	    font-weight: 400;
	    color: #5867DE;
	    cursor: pointer;
	}
	table tfoot,
	table thead{
		background: #f4f3f8;
	}
	.table thead tr:first-child th{
		border-bottom: 1px solid #e9ebf3;
	}
	/*.table tfoot td,*/
	.table thead th{
    	border-left: 1px solid #e9ebf3;
    	font-weight: 600;
	}
	.table tfoot td{
    	font-weight: 600;
	}
	/*table tfoot td:last-child,*/
	/*table thead th:last-child{
		border-bottom:  0px solid #ffffff
	}*/
	.table tfoot td:first-child,
	.table thead th:first-child{
		border-left:  0px solid #ffffff
	}
	.table tbody tr.even{
		background-color: #f9f9f9;
	}
	.search_form{
		padding-top: 5px;
    	padding-bottom: 5px;
	}
	@media (min-width: 1700px){
		.col-xxl-6 {
			max-width: 50%;
			flex: 0 0 50%;
		}
		.col-xxl-3{
			max-width: 25%;
			flex: 0 0 25%;
		}
	}
</style>